var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 15.2C30.4 6.805 23.595 0 15.2 0S0 6.805 0 15.2s6.805 15.2 15.2 15.2c8.391-.009 15.192-6.809 15.2-15.199V15.2zm-25.6 0c0-5.744 4.656-10.4 10.4-10.4s10.4 4.656 10.4 10.4c0 5.744-4.656 10.4-10.4 10.4S4.8 20.944 4.8 15.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.858 17.6a2.4 2.4 0 000-4.8h-2.451a.806.806 0 01-.806-.806V9.543a2.4 2.4 0 00-4.8 0v5.658a2.4 2.4 0 002.4 2.4h5.658z"
  })));
}
export default SvgTimer;